import { render, staticRenderFns } from "./lsdocs2.vue?vue&type=template&id=4bf767b8&scoped=true"
import script from "./lsdocs2.vue?vue&type=script&lang=js"
export * from "./lsdocs2.vue?vue&type=script&lang=js"
import style0 from "./lsdocs2.vue?vue&type=style&index=0&id=4bf767b8&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf767b8",
  null
  
)

export default component.exports